import { AccessRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * updateUserByCustomer - Function that updates on database an access of an user by id  
 * /users/{id}  
 * method PUT  
 * @async-function
 */
const updateUserByCustomer = async (token: string, id: number, model: AccessRequestType) => {
    const response = await api.put(
        `/users/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default updateUserByCustomer;